import { find } from 'lodash'

export default {
  computed: {
    name: {
      get () {
        return this.booking.name
      },

      set (value) {
        this.propertyMutator({ property: 'name', value })
      }
    },

    campaign_id: {
      get () {
        return this.booking.campaign_id
      },

      set (value) {
        this.propertyMutator({ property: 'campaign_id', value })
      }
    },

    nfl_event_type: {
      get () {
        return this.booking.nfl_event_type
      },

      set (value) {
        this.propertyMutator({ property: 'nfl_event_type', value })
      }
    },

    category: {
      get () {
        return this.booking.category_id
      },

      set (value) {
        this.propertyMutator({ property: 'category_id', value })
        if (this.categoryOptions) {
          const category = this.categoryOptions.find(element => element.id === value)
          if (category && category.currency) {
            this.propertyMutator({ property: 'currency', value: category.currency })
          }
        }
      }
    },

    department_id: {
      get () {
        return this.booking.department_id
      },

      set (value) {
        this.propertyMutator({ property: 'department_id', value })
      }
    },

    segment: {
      get () {
        return this.booking.segment
      },

      set (value) {
        this.propertyMutator({ property: 'segment', value })
      }
    },

    organisation_name: {
      get () {
        return this.booking.organisation_name
      },

      set (value) {
        this.propertyMutator({ property: 'organisation_name', value })
      }
    },

    cba: {
      get () {
        return this.booking.cba
      },

      set (value) {
        this.propertyMutator({ property: 'cba', value })
      }
    },

    agency_stage: {
      get () {
        return this.booking.agency_stage
      },

      set (value) {
        this.propertyMutator({ property: 'agency_stage', value })
      }
    },

    opportunities: {
      get () {
        return this.booking.opportunities
      },

      set (value) {
        this.propertyMutator({ property: 'opportunities', value })
        // Set appearance_type as dependent on select opportunities
        let isOnline = find(value, (opp) => opp.appearance_type === 'online')
        let isInPerson = find(value, (opp) => opp.appearance_type === 'in_person')
        let isBoth = find(value, (opp) => opp.appearance_type === 'both') || (isOnline && isInPerson)
        let isOffer = find(value, (opp) => opp.appearance_type === 'offer')
        let appearance
        if (isBoth) {
          appearance = 'both'
        } else if (isOnline) {
          appearance = 'online'
        } else if (isInPerson) {
          appearance = 'in_person'
        } else if (isOffer) {
          appearance = 'offer'
        }
        this.propertyMutator({ property: 'appearance_type', value: appearance })
      }
    },

    online_opportunity_type: {
      get () {
        return this.booking.online_opportunity_id
      },

      set (value) {
        this.propertyMutator({ property: 'online_opportunity_id', value })
      }
    },

    location_unconfirmed: {
      get () {
        return this.booking.location_unconfirmed
      },

      set (value) {
        this.propertyMutator({ property: 'location_unconfirmed', value })
      }
    },

    additional_location_detail: {
      get () {
        return this.booking.additional_location_detail
      },

      set (value) {
        this.propertyMutator({ property: 'additional_location_detail', value })
      }
    },

    establishment: {
      get () {
        return this.booking.establishment
      },

      set (value) {
        this.propertyMutator({ property: 'establishment', value })
      }
    },

    street_address: {
      get () {
        return this.booking.street_address
      },

      set (value) {
        this.propertyMutator({ property: 'street_address', value })
      }
    },

    suburb: {
      get () {
        return this.booking.suburb
      },

      set (value) {
        this.propertyMutator({ property: 'suburb', value })
      }
    },

    state: {
      get () {
        return this.booking.state
      },

      set (value) {
        this.propertyMutator({ property: 'state', value })
      }
    },

    country: {
      get () {
        return this.booking.country
      },

      set (value) {
        this.propertyMutator({ property: 'country', value })
      }
    },

    postcode: {
      get () {
        return this.booking.postcode
      },

      set (value) {
        this.propertyMutator({ property: 'postcode', value })
      }
    },

    area: {
      get () {
        return this.booking.area
      },

      set (value) {
        this.propertyMutator({ property: 'area', value })
      }
    },

    latitude: {
      get () {
        return this.booking.latitude
      },

      set (value) {
        this.propertyMutator({ property: 'latitude', value })
      }
    },

    longitude: {
      get () {
        return this.booking.longitude
      },

      set (value) {
        this.propertyMutator({ property: 'longitude', value })
      }
    },

    commencement_date: {
      get () {
        return this.booking.commencement_date
      },

      set (value) {
        this.propertyMutator({ property: 'commencement_date', value })
      }
    },

    complete_by_date: {
      get () {
        return this.booking.complete_by_date
      },

      set (value) {
        this.propertyMutator({ property: 'complete_by_date', value })
      }
    },

    video_url: {
      get () {
        return this.booking.video_url
      },

      set (value) {
        this.propertyMutator({ property: 'video_url', value })
      }
    },

    date: {
      get () {
        return this.booking.date
      },

      set (value) {
        this.propertyMutator({ property: 'date', value })
      }
    },

    date2: {
      get () {
        return this.booking.date2
      },

      set (value) {
        this.propertyMutator({ property: 'date2', value })
      }
    },

    date3: {
      get () {
        return this.booking.date3
      },

      set (value) {
        this.propertyMutator({ property: 'date3', value })
      }
    },

    arrival_time: {
      get () {
        return this.booking.arrival_time
      },

      set (value) {
        this.propertyMutator({ property: 'arrival_time', value })
      }
    },

    athlete_start_time: {
      get () {
        return this.booking.athlete_start_time
      },

      set (value) {
        this.propertyMutator({ property: 'athlete_start_time', value })
      }
    },

    athlete_leave_time: {
      get () {
        return this.booking.athlete_leave_time
      },

      set (value) {
        this.propertyMutator({ property: 'athlete_leave_time', value })
      }
    },

    duration: {
      get () {
        return this.booking.duration
      },

      set (value) {
        this.propertyMutator({ property: 'duration', value })
      }
    },

    date_flexible_or_unconfirmed: {
      get () {
        return this.booking.date_flexible_or_unconfirmed
      },

      set (value) {
        this.propertyMutator({ property: 'date_flexible_or_unconfirmed', value })
      }
    },

    time_flexible_or_unconfirmed: {
      get () {
        return this.booking.time_flexible_or_unconfirmed
      },

      set (value) {
        this.propertyMutator({ property: 'time_flexible_or_unconfirmed', value })
      }
    },

    required_stars: {
      get () {
        return this.booking.required_stars
      },

      set (value) {
        this.propertyMutator({ property: 'required_stars', value })
      }
    },

    budget_per_star: {
      get () {
        return this.booking.budget_per_star
      },

      set (value) {
        this.propertyMutator({ property: 'budget_per_star', value })
      }
    },

    budget_code: {
      get () {
        return this.booking.budget_code
      },

      set (value) {
        this.propertyMutator({ property: 'budget_code', value })
      }
    },

    budget_not_confirmed: {
      get () {
        return this.booking.budget_not_confirmed
      },

      set (value) {
        this.propertyMutator({ property: 'budget_not_confirmed', value })
      }
    },

    description: {
      get () {
        return this.booking.description
      },

      set (value) {
        this.propertyMutator({ property: 'description', value })
      }
    },

    requirements: {
      get () {
        return this.booking.requirements
      },

      set (value) {
        this.propertyMutator({ property: 'requirements', value })
      }
    },

    expenses_covered: {
      get () {
        return this.booking.expenses_covered
      },

      set (value) {
        this.propertyMutator({ property: 'expenses_covered', value })
      }
    },

    promoted_publicly: {
      get () {
        return this.booking.promoted_publicly
      },

      set (value) {
        this.propertyMutator({ property: 'promoted_publicly', value })
      }
    },

    commission_rate: {
      get () {
        return this.booking.commission_rate
      },

      set (value) {
        this.propertyMutator({ property: 'commission_rate', value })
        this.propertyMutator({ property: 'commission_type', value: 'rate' })
      }
    },

    commission_dollar: {
      get () {
        return this.booking.commission_dollar
      },

      set (value) {
        this.propertyMutator({ property: 'commission_dollar', value })
        this.propertyMutator({ property: 'commission_type', value: 'dollar' })
      }
    },

    commission_type: {
      get () {
        return this.booking.commission_type
      },

      set (value) {
        this.propertyMutator({ property: 'commission_type', value })
      }
    },

    social_media_content: {
      get () {
        return this.booking.social_media_content
      },

      set (value) {
        this.propertyMutator({ property: 'social_media_content', value })
      }
    },

    coupon: {
      get () {
        return this.booking.coupon
      },

      set (value) {
        this.propertyMutator({ property: 'coupon', value })
      }
    },

    others_can_apply: {
      get () {
        return this.booking.others_can_apply
      },

      set (value) {
        this.propertyMutator({ property: 'others_can_apply', value })
      }
    },
    show_all_talents: {
      get () {
        return this.booking.show_all_talents
      },

      set (value) {
        this.propertyMutator({ property: 'show_all_talents', value })
      }
    },
    commercial_purposes: {
      get () {
        return this.booking.commercial_purposes
      },

      set (value) {
        this.propertyMutator({ property: 'commercial_purposes', value })
      }
    },
    video_caption: {
      get () {
        return this.booking.video_caption
      },

      set (value) {
        this.propertyMutator({ property: 'video_caption', value })
      }
    },
    video_message_first_name: {
      get () {
        return this.booking.video_message_first_name
      },

      set (value) {
        this.propertyMutator({ property: 'video_message_first_name', value })
      }
    },
    video_message_last_name: {
      get () {
        return this.booking.video_message_last_name
      },

      set (value) {
        this.propertyMutator({ property: 'video_message_last_name', value })
      }
    },
    video_message_places: {
      get () {
        return this.booking.video_message_places
      },

      set (value) {
        this.propertyMutator({ property: 'video_message_places', value })
      }
    },
    video_rights_length: {
      get () {
        return this.booking.video_rights_length
      },

      set (value) {
        this.propertyMutator({ property: 'video_rights_length', value })
      }
    },
    rights_length: {
      get () {
        return this.booking.rights_length
      },

      set (value) {
        this.propertyMutator({ property: 'rights_length', value })
      }
    },
    ambassadorship_details: {
      get () {
        return this.booking.ambassadorship_details
      },

      set (value) {
        this.propertyMutator({ property: 'ambassadorship_details', value })
      }
    },
    ambassador_length: {
      get () {
        return this.booking.ambassador_length
      },

      set (value) {
        this.propertyMutator({ property: 'ambassador_length', value })
      }
    },
    target_market: {
      get () {
        return this.booking.target_market
      },

      set (value) {
        this.propertyMutator({ property: 'target_market', value })
      }
    },
    marketing_channels: {
      get () {
        return this.booking.marketing_channels
      },

      set (value) {
        this.propertyMutator({ property: 'marketing_channels', value })
      }
    },
    shoot_required: {
      get () {
        return this.booking.shoot_required
      },

      set (value) {
        this.propertyMutator({ property: 'shoot_required', value })
      }
    },
    post_caption: {
      get () {
        return this.booking.post_caption
      },

      set (value) {
        this.propertyMutator({ property: 'post_caption', value })
      }
    },
    social_post_location: {
      get () {
        return this.booking.social_post_location
      },

      set (value) {
        this.propertyMutator({ property: 'social_post_location', value })
      }
    },
    number_of_social_media_posts: {
      get () {
        return this.booking.number_of_social_media_posts
      },

      set (value) {
        this.propertyMutator({ property: 'number_of_social_media_posts', value })
      }
    },
    paid_advertising: {
      get () {
        return this.booking.paid_advertising
      },

      set (value) {
        this.propertyMutator({ property: 'paid_advertising', value })
      }
    },
    other: {
      get () {
        return this.booking.other
      },

      set (value) {
        this.propertyMutator({ property: 'other', value })
      }
    },
    other_agency_stage: {
      get () {
        return this.booking.other_agency_stage
      },

      set (value) {
        this.propertyMutator({ property: 'other_agency_stage', value })
      }
    },
    other_video_usage: {
      get () {
        return this.booking.other_video_usage
      },

      set (value) {
        this.propertyMutator({ property: 'other_video_usage', value })
      }
    },

    region_id: {
      get () {
        return this.booking.region_id
      },

      set (value) {
        this.propertyMutator({ property: 'region_id', value })
      }
    },

    travel_time: {
      get () {
        return this.booking.travel_time
      },

      set (value) {
        this.propertyMutator({ property: 'travel_time', value })
      }
    },

    //            TODO: Booking custom fields CU-3judex
    aca_event_location: {
      get () {
        return this.booking.aca_event_location
      },
      set (value) {
        this.propertyMutator({ property: 'aca_event_location', value })
      }
    },

    aca_event_distance: {
      get () {
        return this.booking.aca_event_distance
      },
      set (value) {
        this.propertyMutator({ property: 'aca_event_distance', value })
      }
    },

    aca_event_gender: {
      get () {
        return this.booking.aca_event_gender
      },
      set (value) {
        this.propertyMutator({ property: 'aca_event_gender', value })
      }
    },

    aca_number_participants: {
      get () {
        return this.booking.aca_number_participants
      },
      set (value) {
        this.propertyMutator({ property: 'aca_number_participants', value })
      }
    },

    aca_participant_ability: {
      get () {
        return this.booking.aca_participant_ability
      },
      set (value) {
        this.propertyMutator({ property: 'aca_participant_ability', value })
      }
    },
    //            TODO: Booking custom fields CU-3judex

    dress_code: {
      get () {
        return this.booking.dress_code
      },
      set (value) {
        this.propertyMutator({ property: 'dress_code', value })
      }
    },

    cost_centre: {
      get () {
        return this.booking.cost_centre
      },

      set (value) {
        this.propertyMutator({ property: 'cost_centre', value })
      }
    },

    gl_code: {
      get () {
        return this.booking.gl_code
      },

      set (value) {
        this.propertyMutator({ property: 'gl_code', value })
      }
    }
  }
}
